import { MenuConfigurationSettingsT } from '@features/orderForm/stepMenuConfiguration/types/menuConf.type';
import { formApi } from '@services/api/form';

export const orderFormSteps = formApi.injectEndpoints({
  endpoints: build => ({
    getMenuConfigurationSettings: build.query<
      MenuConfigurationSettingsT,
      { dietCaloriesId: number; companyId: string; cityId: number }
    >({
      query: ({ cityId, companyId, dietCaloriesId }) => ({
        method: 'GET',
        url: `form/open/order-form/steps/menu-configuration/settings`,
        params: {
          cityId,
          dietCaloriesId,
        },
        headers: {
          'company-id': companyId,
        },
      }),
      keepUnusedDataFor: 3600,
    }),
  }),
});

export const { useGetMenuConfigurationSettingsQuery } = orderFormSteps;
